/* tslint:disable */

export class Text {
		Id: number;
		FormId: number;
		TextKey: string;
		DefaultValue: string;
		CustomValue: string;
		ValueListId: number;
		ValueListItemId: number;
		PairId: number;
		ValueForTrue: string;
		ValueForFalse: string;

}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/Text.ts